import styled from 'styled-components';

import { mediaConfined } from '@xingternal/layout-tokens';
import {
  scale030,
  space4XL,
  spaceL,
  spaceM,
  spaceS,
  spaceXL,
  spaceXS,
  xdlColorControlFillTertiary,
  xdlColorTextOnLight,
} from '@xingternal/tokens';
import { Headline } from '@xingternal/typography';

export const Container = styled.div`
  margin-bottom: ${space4XL};
`;

export const Title = styled(Headline)`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXL};
  }
`;

export const RelatedJobsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const RelatedJob = styled.a`
  background-color: ${xdlColorControlFillTertiary};
  border-radius: ${spaceXS};
  color: ${xdlColorTextOnLight};
  margin: 0 ${spaceS} ${spaceM} 0;
  padding: ${scale030} ${spaceL};
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;
